import {
    FETCH_REPORT,
    SAVE_REPORT,
    RESET_STATE,
    CUSTOM_REPORT_FETCH_CHART,
    CUSTOM_REPORT_SAVE_BOT_STATUS,
    CUSTOM_REPORT_SAVE_BOT_CHARTS,
    CUSTOM_REPORT_CREATE_BOT,
    FETCH_JOURNEY_REPORT_METADATA,
    SAVE_JOURNEY_REPORT_METADATA
} from "../constants/dashboard";

const initState = {
    reports: {
        agent: {
            bottomRow: [],
            topRow: [],
            userByDevice: [],
            summary: [],
            ticketAggregated: []
        },
        bot: {
            topCard: [],
            midRow: [],
            others: [],
            secondRow: [],
            journey: []
        },
        campaign: {
            topCard: [],
            midRow: []
        },
        customAnalytics: {
            journeyFunnel: []
        }
    },
    customReports: {
        botStatus: null,
        reports: []
    },
    journeyMeta: [],
    loading: false
};

const dashboard = (state = initState, action) => {
    switch (action.type) {
        case FETCH_REPORT:
            return {
                ...state,
                loading: true
            };
        case SAVE_REPORT:
            let newReports = state.reports;
            newReports[action.payload.type][action.payload.subtype] = [...action.payload.data];
            return {
                ...state,
                reports: {...newReports},
                loading: false
            }
        case RESET_STATE:
            return {
                reports: {
                    agent: {
                        bottomRow: [],
                        topRow: [],
                        userByDevice: [],
                        summary: [],
                        ticketAggregated: []
                    },
                    bot: {
                        topCard: [],
                        midRow: [],
                        others: [],
                        secondRow: []
                    },
                    campaign: {
                        topCard: [],
                        midRow: []
                    },
                    customAnalytics: {
                        journeyFunnel: []
                    }
                },
                customReports: {
                    botStatus: null,
                    reports: []
                },
                journeyMeta: [],
                loading: false
            }
        case CUSTOM_REPORT_FETCH_CHART:
            return {
                ...state
            }
        case CUSTOM_REPORT_SAVE_BOT_STATUS: {
            return {
                ...state,
                customReports: {
                    ...state.customReports,
                    botStatus: action.payload   
                }
            }
        }
        case CUSTOM_REPORT_SAVE_BOT_CHARTS: {
            return {
                ...state,
                customReports: {
                    ...state.customReports,
                    reports: [...action.payload]
                }
            }
        }
        case CUSTOM_REPORT_CREATE_BOT: {
            return {
                ...state
            }
        }
        case FETCH_JOURNEY_REPORT_METADATA:
            return {
                ...state
            }
        case SAVE_JOURNEY_REPORT_METADATA:
            return {
                ...state,
                journeyMeta: [...action.payload]
            }
        default:
            return state;
    }
};



export default dashboard;
